module.exports = __webpack_public_path__ + "media/images/payments/worldpay-dark-34f766abb73b9a47873b99c777f5c39b.svg";